// Central list of API endpoints that should trigger a quota refresh
// Keep endpoints in lowercase for case-insensitive matching against request URLs
export const QUOTA_RELEVANT_ENDPOINTS: readonly string[] = [
  "/api/avm",
  "/api/portfolio/saveobjectinformation",
  "/api/portfolio/getobjectlocation",
  "/api/portfolio/getportfolioqualifyingdate",
  "/api/portfolio/getobjectavm",
  "/api/portfolio/completeobject",
  "/api/portfolio/unlockportfoliotimeslice"
] as const;
